import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { GRADES, ACADEMIC_YEARS, sectionsForGrade } from "../lib/constants";

export function FieldText({ id, label, value, onChange, placeholder, type = "text", required, testid }) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-sm font-medium text-slate-700">{label}{required && <span className="text-red-500 mx-1">*</span>}</Label>
      <Input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        className="bg-white text-right h-11"
        dir="rtl"
        data-testid={testid}
      />
    </div>
  );
}

export function FieldGrade({ value, onChange, testid = "grade-select" }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-medium text-slate-700">الصف الدراسي<span className="text-red-500 mx-1">*</span></Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-white h-11 text-right" dir="rtl" data-testid={testid}>
          <SelectValue placeholder="اختر الصف" />
        </SelectTrigger>
        <SelectContent dir="rtl">
          {GRADES.map(g => <SelectItem key={g} value={g} data-testid={`grade-option-${g}`}>{g}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function FieldSection({ grade, value, onChange, testid = "section-select" }) {
  const options = sectionsForGrade(grade);
  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-medium text-slate-700">الفصل<span className="text-red-500 mx-1">*</span></Label>
      <Select value={value} onValueChange={onChange} disabled={!grade}>
        <SelectTrigger className="bg-white h-11 text-right" dir="rtl" data-testid={testid}>
          <SelectValue placeholder={grade ? "اختر الفصل" : "اختر الصف أولاً"} />
        </SelectTrigger>
        <SelectContent dir="rtl">
          {options.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function FieldEnrollmentStatus({ value, onChange, testid = "enrollment-status-select" }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-medium text-slate-700">حالة الطالب<span className="text-red-500 mx-1">*</span></Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-white h-11 text-right" dir="rtl" data-testid={testid}>
          <SelectValue placeholder="اختر الحالة" />
        </SelectTrigger>
        <SelectContent dir="rtl">
          <SelectItem value="مستجد">مستجد</SelectItem>
          <SelectItem value="مستمر">مستمر</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

export function FieldAcademicYear({ value, onChange, testid = "academic-year-select" }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-medium text-slate-700">العام الدراسي<span className="text-red-500 mx-1">*</span></Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-white h-11 text-right" dir="rtl" data-testid={testid}>
          <SelectValue placeholder="اختر العام الدراسي" />
        </SelectTrigger>
        <SelectContent dir="rtl">
          {ACADEMIC_YEARS.map(y => <SelectItem key={y} value={y}>{y}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
